<template>
    <div class="toast" :class="type? `toast--${type}`:''">
        <div class="toast-box">
            <div class="toast-box__header" v-if="title !== null">
                <div class="toast-box__title">

                    <span>{{ title }}</span>
                </div>
                <button
                        type="button"
                        class="toast-box__headerbtn"
                        aria-label="Close"
                        v-if="showClose"
                        @click="handleAction"
                        @keydown.enter="handleAction">
                    <i class="toast-box__close el-icon-close"></i>
                </button>
            </div>
            <div class="toast-box__content">
                <div class="toast-box__container">

                    <div class="toast-box__message">
                        <img src="../../assets/images/nodata.png"/>
                        <p>{{content}}</p>
                    </div>
                </div>

            </div>

            <!--            <div class="el-message-box__btns">-->
            <!--                <el-button-->
            <!--                        :loading="cancelButtonLoading"-->
            <!--                        :class="[ cancelButtonClasses ]"-->
            <!--                        v-if="showCancelButton"-->
            <!--                        :round="roundButton"-->
            <!--                        size="small"-->
            <!--                        @click.native="handleAction('cancel')"-->
            <!--                        @keydown.enter="handleAction('cancel')">-->
            <!--                    {{ cancelButtonText || t('el.messagebox.cancel') }}-->
            <!--                </el-button>-->
            <!--                <el-button-->
            <!--                        :loading="confirmButtonLoading"-->
            <!--                        ref="confirm"-->
            <!--                        :class="[ confirmButtonClasses ]"-->
            <!--                        v-show="showConfirmButton"-->
            <!--                        :round="roundButton"-->
            <!--                        size="small"-->
            <!--                        @click.native="handleAction('confirm')"-->
            <!--                        @keydown.enter="handleAction('confirm')">-->
            <!--                    {{ confirmButtonText || t('el.messagebox.confirm') }}-->
            <!--                </el-button>-->
            <!--            </div>-->

        </div>


    </div>
</template>

<script>
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
export default {
  name: "Token-error-modal",
  data() {
    return {
      title: "提示",
      showClose: false,
      content: '当前获取到的token值无法登录本页面，请更新后重试。',
      duration: 3000,//定时器时间
      type: ''
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.$destroy(true);//3s后进行销毁
    //   this.$el.parentNode.removeChild(this.$el);
    // },this.duration);
  },
  methods: {
    handleAction() {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.3);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    z-index: 9999;
    /*background: transparent;*/

    .toast-box {

        /*display: inline-block;*/
        width: 460px;
        padding-bottom: 10px;
        vertical-align: middle;
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        font-size: 18px;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        text-align: left;
        overflow: hidden;

        .toast-box__header {
            display: flex;
            font-size: 18px;
            line-height: 55px;
            height: 55px;
            /*justify-content: flex-end;*/
            border-bottom: solid 1px #dddddd;

            .toast-box__title {
                margin-left: 0px;
                /*text-align: left;*/
                display: block;
                width: calc(100% - 40px);
                padding: 0 20px;
                /*text-align: center;*/
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #303133;
            }

            .toast-box__headerbtn {
                color: #dddddd;
                display: block;
                width: 20px;
                cursor: pointer;
                /*margin-right: 20px;*/
                font-size: 20px;
                border: none;
                background: transparent;

                .toast-box__close {
                    color: #909399;
                }

                &:focus, &:hover {
                    .toast-box__close {
                        color: #226cfb;
                    }
                }
            }

        }

        .toast-box__content {
            padding: 10px 10px 0px;
            display: flex;
            justify-content: center;
            align-items: center;

            .toast-box__container {
                .toast-box__message {
                    display: flex;
                    flex-flow: column;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 150px;
                        height: 120px;
                    }

                    p {
                        padding: 0px;
                        margin-top: 20px;
                        font-size: 16px;
                        color: #606266;
                    }
                }
            }
        }

    }


    /*p {*/
    /*    padding: 0.24rem 0.44rem;*/
    /*    font-size: 0.36rem;*/
    /*    border-radius: 0.08rem;*/
    /*    background: rgba(17, 17, 17, 0.7);*/
    /*}*/


}

</style>
